import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

import { Layout, SEO } from "src/components/common"

import { useMeta } from "src/utils"

export default props => {
  const { terms } = useStaticQuery(QUERY)
  const file = terms.sections[0].components[0].file.file
  const meta = useMeta({ ...terms })

  return (
    <Layout pageContext={props.pageContext}>
      <SEO {...meta} />
      <Terms>
        <iframe
          title="terms-and-conditions"
          src={file.url}
          height="100%"
          width="100%"
          frameborder="0"
        ></iframe>
      </Terms>
    </Layout>
  )
}

const QUERY = graphql`
  {
    terms: contentfulPage(pageId: { eq: "terms-and-conditions" }) {
      ...Page
    }
  }
`

const Terms = styled.main`
  height: 100vh;
  overflow: hidden;
`
